export default __webpack_public_path__ + "media/color/nano-ed8bb567.svg";